module.exports = __webpack_public_path__ + "img/icon-category-motorhome-bg.191f479d.jpg";